__turbopack_context__.v({
  "project-card": "ProjectCard-module-sass-module__soVPTa__project-card",
  "project-card--visible": "ProjectCard-module-sass-module__soVPTa__project-card--visible",
  "project-card__background": "ProjectCard-module-sass-module__soVPTa__project-card__background",
  "project-card__content": "ProjectCard-module-sass-module__soVPTa__project-card__content",
  "project-card__cta": "ProjectCard-module-sass-module__soVPTa__project-card__cta",
  "project-card__image": "ProjectCard-module-sass-module__soVPTa__project-card__image",
  "project-card__image-mask": "ProjectCard-module-sass-module__soVPTa__project-card__image-mask",
  "project-card__image__container": "ProjectCard-module-sass-module__soVPTa__project-card__image__container",
  "project-card__title": "ProjectCard-module-sass-module__soVPTa__project-card__title",
  "project-card__title-inner": "ProjectCard-module-sass-module__soVPTa__project-card__title-inner",
});
